import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

export declare type WheelDirection = 'up' | 'down';

@Directive({
  selector: '[ackMouseWheel]'
})
export class MouseWheelDirective {

  @Output() public wheelMove: EventEmitter<WheelDirection>;

  constructor() {
    this.wheelMove = new EventEmitter();
  }

  @HostListener('wheel', ['$event'])
  public wheel(event: WheelEvent) {

    const direction: WheelDirection = event.deltaY > 0 ? 'down' : 'up';

    this.wheelMove.emit(direction);

  }

}
